import { render, staticRenderFns } from "./AMS.vue?vue&type=template&id=1dbac132&scoped=true&lang=pug"
import script from "./AMS.js?vue&type=script&lang=js&external"
export * from "./AMS.js?vue&type=script&lang=js&external"
import style0 from "./AMS.vue?vue&type=style&index=0&id=1dbac132&prod&scoped=true&lang=sass"
import style1 from "./AMS.vue?vue&type=style&index=1&id=1dbac132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbac132",
  null
  
)

export default component.exports